import styled from 'styled-components';

import {OutlookPersonFromEmailJson} from '../../../requests';
import LoxoRecipient from './LoxoRecipient';
import {NoRecipients, RecipientsTitle} from './styles';

interface Props {
  loxoPeople: OutlookPersonFromEmailJson[];
  syncableEmailAddresses: string[];
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const LoxoRecipients = ({loxoPeople, syncableEmailAddresses}: Props) => {
  return (
    <Container>
      <RecipientsTitle>Already in Loxo ({loxoPeople.length})</RecipientsTitle>
      {loxoPeople.length === 0 ? (
        <NoRecipients>None</NoRecipients>
      ) : (
        <>
          {loxoPeople.map((person) => (
            <LoxoRecipient
              key={person.id}
              person={person}
              syncableEmailAddresses={syncableEmailAddresses}
            />
          ))}
        </>
      )}
    </Container>
  );
};

export default LoxoRecipients;
